// extracted by mini-css-extract-plugin
export default {"FE-700":"#D82B39","CG-800":"#333D47","clock":"G42fd30","highlight":"Gc41556","highlightIsCritical":"G28e4f7","clockSvg":"Gfdb1b8","text":"G7b8faa","textIsCritical":"Gb558cb"};